import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { COLLECT_STATUS_CONFIG } from '../../../../constants';
import { CollectStatus, OutOfStockReason } from '../../../../types';
import * as Styled from './StatusPanels.styles';

interface OutOfStockPanelProps {
  onConfirm: (reason: OutOfStockReason) => void;
  onCancel: () => void;
}

const config = COLLECT_STATUS_CONFIG[CollectStatus.OUT_OF_STOCK];

const REASONS: { key: OutOfStockReason; labelKey: string }[] = [
  {
    key: 'in_database',
    labelKey: 'OrderPage.Collect.OutOfStockModal.IN_DATABASE',
  },
  { key: 'in_fact', labelKey: 'OrderPage.Collect.OutOfStockModal.IN_FACT' },
];

const OutOfStockPanel = ({ onConfirm, onCancel }: OutOfStockPanelProps) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<OutOfStockReason | null>(null);

  return (
    <Styled.PanelContainer
      accentColor={config.color}
      accentBackground={config.background}
      accentBorder={config.border}
    >
      <div className="panel-title">
        {t('OrderPage.Collect.OutOfStockModal.TITLE')}
      </div>
      <Styled.ReasonsGrid>
        {REASONS.map((reason) => (
          <button
            key={reason.key}
            type="button"
            className={`reason-button ${
              selected === reason.key ? 'selected' : ''
            }`}
            onClick={() => setSelected(reason.key)}
          >
            {t(reason.labelKey)}
          </button>
        ))}
      </Styled.ReasonsGrid>
      <div className="panel-actions">
        <button
          type="button"
          className="panel-button cancel"
          onClick={onCancel}
        >
          {t('OrderPage.Collect.OutOfStockModal.CANCEL')}
        </button>
        <button
          type="button"
          className="panel-button confirm"
          style={{ background: config.color }}
          disabled={!selected}
          onClick={() => selected && onConfirm(selected)}
        >
          {t('OrderPage.Collect.OutOfStockModal.CONFIRM')}
        </button>
      </div>
    </Styled.PanelContainer>
  );
};

export default OutOfStockPanel;
